import React from "react";
import dynamic from "next/dynamic";

// Dynamic imports
import Section from "@/Components/LayoutComponents/Section";
const Slider = dynamic(() => import("./Slider"), { ssr: false });

interface AwardsProps {
  data?: any;
  isMobile?: boolean;
}

const Partner: React.FC< AwardsProps> = ({ data, isMobile  }) =>  {
  return (
    <Section className="overflow-hidden">
      <div className="container">
        <div className="max-w-[948px] mx-auto text-center">
          <h2 className="text-heading-1 text-primary-text font-bold capitalize">
            {data?.title}
          </h2>
          <p className="text-subtitle-2 font-regular mt-3">{data?.sub_title}</p>
        </div>
      </div>
      <div className="container !px-0">
        <div className="mt-10">
          <Slider sliderData={data?.partners} getMobile={isMobile} />
        </div>
      </div>
    </Section>
  );
};
export default Partner;
